import React from "react"
import { Box, Typography } from "@mui/material"


export default function reportNameColumn() {
	return [{
		name: 'id_main_site_translation', label: 'Main site',
		options: {
			customBodyRowRender: value => value ? value : 'Not assigned',
			display: 'excluded'
		}
	}, {
		name: 'notificationTo', label: 'Notification To',
		options: { display: 'excluded' }
	}, {
		name: "name", label: "Report name",
		options: {
			headerAlign: 'left',
			filter: false,
			customBodyRowRenderLite: (value, rowData) => <ReportNameCell reportName={value} rowData={rowData}/>
		}
	}]
}

const ReportNameCell = ({ reportName }) => {

	return <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: 1 }}>
		<Typography variant="subtitle1">
			{reportName}
		</Typography>
	</Box>
}